import Vue from "vue";
import PouchDB from "pouchdb";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import App from "./App.vue";
import router from "./router";
import { OverpassApiServiceFactory } from "@/services/OverpassApiService";
const OverpassApiService = OverpassApiServiceFactory(fetch);
import storeFactory from "@/store/index.ts";
import "./registerServiceWorker";

import "./../node_modules/bulma/css/bulma.css";
import i18n from "./i18n";

if (
  localStorage.getItem("preferences") &&
  JSON.parse(localStorage.getItem("preferences")).sentryErrorTrackingOptIn
) {
  Sentry.init({
    dsn: "https://2bc511534ce34f84a238a925a30af910@o409470.ingest.sentry.io/5282123",
    integrations: [
      new VueIntegration({ Vue, attachProps: false, logErrors: true }),
    ],
    release: "meal-planner@" + process.env.VUE_APP_RELEASE_STRING || "dev",
  });
}

Vue.config.productionTip = false;

const overpassApiService = new OverpassApiService();
const db = new PouchDB("meal-planner");
const store = storeFactory(db, navigator, location, overpassApiService);

new Vue({
  router,
  store,

  async beforeCreate() {
    await this.$store.dispatch("refreshFromPersistance");
    await this.$store.dispatch("runDataMigrations");
    await this.$store.dispatch("archiveOldEntries");
    await this.$store.dispatch("deleteObsoleteArchivedEntries");
  },
  mounted() {
    this.$router.afterEach((to: any) => {
      this.$store.commit("saveLatestRoute", to.fullPath);
    });
  },
  i18n,
  render: (h) => h(App),
}).$mount("#app");
